(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('ProyectosAprobadosPorAreaController', ProyectosAprobadosPorAreaController);

    ProyectosAprobadosPorAreaController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'reporte', 'centrosDocentes', 'programasEducativos', 'sSEstatusProyecto', 'sSAmbitos', 'sSPeriodos', 'ReporteDownloadService'];

    function ProyectosAprobadosPorAreaController ($rootScope, $state, $timeout, Auth, $uibModalInstance, reporte, centrosDocentes, programasEducativos, sSEstatusProyecto, sSAmbitos, sSPeriodos, ReporteDownloadService) {
        var vm = this;
        
        vm.reporte = reporte;
        
        sSPeriodos.$promise.then(function(sSPeriodos) {
          	vm.sSPeriodos = sSPeriodos;
          	vm.selectedSSPeriodo = sSPeriodos[0];
        });
        
        vm.sSAmbitos = sSAmbitos;
        
        centrosDocentes.$promise.then(function(centroDocentes) {
        	vm.centrosDocentes = centroDocentes;
            vm.selectedCentroDocente = centroDocentes[0];
        });
        
      	vm.programasEducativos = programasEducativos;
    	vm.sSEstatusProyecto = sSEstatusProyecto;
        
        vm.cancel = cancel;
        vm.save = save;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	ReporteDownloadService.proyectosAprobadosPorArea(
                    vm.selectedSSPeriodo.id,
                    vm.selectedCentroDocente.id
                ).then(function () {
                	console.log("DONE");
                }).catch(function () {
                });
        }
    }
})();
